import { Alert } from "ui/alert";

const FormErrors = ({ form }: { form: any }) => {
  return (
    <Alert
      severity="error"
      data-testid="form-errors"
      title="Form cannot save due to the following errors:"
      sx={{ mb: 4 }}>
      <ul className="list-disc pl-5">
        {Object.entries(form.errors).map(([field, errorMessage]) => (
          <li key={field}>
            {field}: {errorMessage as string}
          </li>
        ))}
      </ul>
    </Alert>
  );
};

export default FormErrors;
